export enum PomAnnouncementPeriod {
  Yearly = "yearly",
  Monthly = "monthly",
}

export function getTranslationKeyOfPeriod(period: PomAnnouncementPeriod): string {
  switch (period) {
    case PomAnnouncementPeriod.Monthly:
      return "pom.contract.period.monthly";
    case PomAnnouncementPeriod.Yearly:
      return "pom.contract.period.yearly";
  }
}
